'use strict';
module.exports = require('./Toolbar.vue');